
import { VerificationStatus } from "./constant";
import _ from "lodash";
import dayjs from "dayjs"

export const getStatusColor = (status) => {
    switch (status) {
        case VerificationStatus.DRAFT:
            return "blue";
        case VerificationStatus.INCOMPLETE:
            return "gold";
        case VerificationStatus.PENDING:
            return "orange";
        case VerificationStatus.VERIFIED:
            return "green";
        case VerificationStatus.FAILED:
            return "red";
        case VerificationStatus.EXPIRED:
            return "gray";
        default:
            return "default";
    }
};

export const extractLocalizedValue = (data) => {
    if (!data) return "";

    const lang = localStorage.getItem("language") || "en";

    if (typeof data === "string") return data.trim?.() || data;

    if (Array.isArray(data)) {
        const found = data.find((entry) => entry?.language === lang);
        if (found?.content) return found.content.trim();

        const fallback = data.find((entry) => entry?.language === "en");
        if (fallback?.content) return fallback.content.trim();

        return "";
    }

    if (typeof data === "object") {
        return data[lang]?.trim?.() || data["en"]?.trim?.() || "";
    }

    return "";
};

export function getFullUrl(baseUrl, path) {
    if (!path) return "";
    if (/^(https?:|blob:)/i.test(path)) return path;
    return `${baseUrl.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
}

// convert absolute path to relative path
const normalizeFilePath = (url) => {
    if (typeof url !== "string") return url;
    // Removes https://something.com/ part
    return url.replace(/^https?:\/\/[^/]+\//, "");
};

function getValueByPath(obj, pathArray) {
    if (!obj) return null;
    return pathArray.reduce((current, key) => {
        if (current == null) return null;
        return current.hasOwnProperty(key) ? current[key] : null;
    }, obj);
}

export function buildSteps(formValues, steps = [], parentPath = []) {
    return (steps || []).map((step) => {
        const { sourceDoc, sourceType } = step;
        const field = sourceDoc || {};
        const fieldId = field._id;

        // full path to this field inside the form values (array)
        const fieldPath = [...parentPath, fieldId];

        const currentRoot = parentPath.length ? getValueByPath(formValues, parentPath) || {} : formValues || {};

        let value = getValueByPath(currentRoot, [fieldId]);
        let expiredAtValue = getValueByPath(formValues, ["expiredAt", ...fieldPath]);

        if (
            (sourceType && sourceType.toString().toLowerCase() === "document_setting") ||
            Array.isArray(step.steps) && step.steps.length > 0 ||
            Array.isArray(field.steps) && field.steps.length > 0
        ) {
            const nestedSourceSteps = step.steps || field.steps || [];

            const nestedSteps = buildSteps(formValues, nestedSourceSteps, fieldPath);

            return {
                sourceId: fieldId,
                sourceType,
                value: {
                    steps: nestedSteps,
                },
            };
        }

        // Normalize file values
        if (field?.type === "file") {
            if (typeof value === "string") {
                value = normalizeFilePath(value);
            } else if (value && typeof value === "object") {
                value = normalizeFilePath(value?.file?.response || value?.url || value);
            }
        }

        if (field?.type === "phone_number") {
            if (value && typeof value === "object") {
                const { countryCode, phoneNumber } = value
                value = `${countryCode || ""}${phoneNumber || ""}`
            }
        }

        // Date/time conversions
        if (value && dayjs.isDayjs(value)) {
            switch (field?.type) {
                case "date":
                    value = value.format("YYYY-MM-DD");
                    break;
                case "datetime":
                    value = value.format("YYYY-MM-DD HH:mm:ss");
                    break;
                case "time":
                    value = value.format("HH:mm:ss");
                    break;
                default:
                    value = value.toISOString();
            }
        }

        // Convert expiredAt dayjs
        if (expiredAtValue && dayjs.isDayjs(expiredAtValue)) {
            expiredAtValue = expiredAtValue.toISOString();
        }


        // if (value && typeof value === "object" && !Array.isArray(value) && field?.type === "multi_select") {
        //     // convert numeric-key obj to array in order
        //     const arr = Object.keys(value)
        //         .map((k) => ({ k, n: parseInt(k, 10) }))
        //         .filter(({ n }) => !Number.isNaN(n))
        //         .sort((a, b) => a.n - b.n)
        //         .map(({ k }) => value[k]);
        //     value = arr;
        // }

        return {
            sourceId: fieldId,
            sourceType,
            value:
                value === undefined || value === "" || value === null
                    ? null
                    : value,
            ...(expiredAtValue ? { expiredAt: expiredAtValue } : {}),
        };
    });
}

export const cleanStep = (step) => {
    const {invalid, ...rest} = step
    if (rest.value && typeof rest.value === 'object' && Array.isArray(rest.value.steps)) {
        return {
            ...rest,
            value: {
                ...rest.value,
                steps: rest.value.steps.map(cleanStep)
            }
        }
    }
    return rest
}